import bodyScrollClass from './bodyScrollClass.js';
import headerLogoScroll from './headerLogoScroll.js';
import MainNavigation from './mainNavigation.js';
import WidgetNavigation from './widgetNavigation';
import ResponsiveTable from './ResponsiveTable.js';
import VideoElement from './VideoElement';
import GoogleMapElement from './GoogleMapElement';
import InfoLayer from './InfoLayer';
import accordion from './accordion';
import NewsTeaser from './NewsTeaser';
import YachtofficeTeaser from './YachtofficeTeaser';
import ImageLightbox from './ImageLightbox';

document.initAllPageScripts = () => {
  bodyScrollClass();
  headerLogoScroll();

  new MainNavigation({
    toggleElement: $('.main-navigation__toggle'),
    navigationElement: $('.main-navigation__list.level-1')
  });

  $('.news-teaser').each((index, elm) => {
    new NewsTeaser($(elm));
  })

  $('.widget-navigation').each((index, elm) => {
    new WidgetNavigation($(elm));
  });

  new ResponsiveTable();

  $('.text-with-video').each((index, item) => {
    new VideoElement($(item));
  });

  $('.googlemap').each((index, item) => {
    new GoogleMapElement($(item));
  });

  $('.yachtoffice-connector-teaser').each((index, item) => {
    new YachtofficeTeaser($(item));
  });

  new ImageLightbox();

  new InfoLayer();
}

document.addEventListener('DOMContentLoaded', event => {
  document.initAllPageScripts();
});

document.addEventListener('DOMContentLoadedYachtoffice', () => {
  console.log('DOMContentLoadedYachtoffice');
  document.initAllPageScripts();
});
